<script>
	import { onMount } from "svelte";
	import { Col, Row } from "sveltestrap";
	import CarDetailsCard from "../../../components/DetailsCard/CarDetailsCard.svelte";
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import {
		loading,
		carDetail,
		evMasterData,
		toastMessage,
		errorMessage,
	} from "../../../store/store";
	import About from "./About.svelte";
	import CarIssues from "./CarIssues/CarIssues.svelte";
	import Booking from "./CarBookings/MainBooking.svelte";
	import { getEvMasterData } from "../../../services/profile.ts";
	import ConfirmModal from "../../../components/CustomModal/ConfirmModal.svelte";
	import { getVehicleDetails, lockUnlockCar } from "src/services/vehicle";
	import ErrorMessageHandler from "src/components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { extractErrorMessage, scrollToTop } from "src/utils/misc";
	import CarActivities from "./CarActivities/CarActivities.svelte";

	export let vehicleId;

	let items = [
		{
			label: "About",
			value: 1,
			component: About,
		},
		{
			label: "Car Issues",
			value: 5,
			component: CarIssues,
		},
		{
			label: "Bookings",
			value: 4,
			component: Booking,
		},
		{
			label: "Activities",
			value: 6,
			component: CarActivities,
		},
		,
	];

	let modalDialog = {
		lock: {
			header: "Lock Car",
			bodyText:
				"You are about to lock this car. Please provide a reason for locking.",
		},
		unlock: {
			header: "Unlock Car",
			bodyText:
				"You are about to unlock this car. Please provide a reason for unlocking.",
		},
	};

	let detailData;
	let selectedOption = "";
	let otherReason = "";

	$: options = [
		{
			value: `Unable to ${action} via Operator App`,
			label: `Unable to ${action} via Operator App`,
		},
		{ value: `Request from workshop`, label: `Request from workshop` },
		{ value: `Others`, label: `Others` },
	];
	$: isModalOpen = false;
	$: action = "";

	function toggle(actionType = "") {
		action = actionType;
		isModalOpen = !isModalOpen;
		selectedOption = "";
		otherReason = "";
	}
	async function handleSubmit() {
		try {
			let remarks =
				selectedOption === "Others" ? otherReason : selectedOption;
			const response = await lockUnlockCar(action, vehicleId, remarks);
			if (response.status === 200) {
				toastMessage.set({
					type: "success",
					message: `Request sent.`,
				});
				remarks = "";
			}
		} catch (error) {
			console.error(error);
			extractErrorMessage(`Vehicle ${action} was unsuccessful`);
			setTimeout(() => {
				scrollToTop();
			}, 300);
		} finally {
			toggle();
		}
	}

	onMount(async () => {
		try {
			loading.set(true);
			const response = await getVehicleDetails(vehicleId);
			const resEvMasterData = await getEvMasterData();
			detailData = response.data;
			carDetail.set(response.data);
			evMasterData.set(resEvMasterData.data.data);
		} catch (error) {
			console.log(error);
			console.error(error.response);
		} finally {
			loading.set(false);
		}
	});
</script>

{#if !detailData}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<Row>
			<ErrorMessageHandler message={$errorMessage} />
			<Col xs={4}>
				<h5>Car Details</h5>
				<CarDetailsCard {detailData} {toggle} />
			</Col>
			<Col xs={8}>
				<Tabs {items} {detailData} {vehicleId} />
			</Col>
		</Row>
		<ConfirmModal
			header={modalDialog[action]?.header}
			bodyText={modalDialog[action]?.bodyText}
			buttonColor="primary"
			open={isModalOpen}
			{toggle}
			isDropdownEnabled={true}
			{options}
			{action}
			{handleSubmit}
			bind:selectedOption
			bind:otherReason
		/>
	</LoaderContainer>
{/if}
